import { ProjectStatusCategory } from "@/enums/ProjectStatusCategory";
import { z } from "zod";

export const ProjectStatusSchema = z.object({
  projectStatusId: z.number(),
  category: z.nativeEnum(ProjectStatusCategory),
  name: z.string(),
});

export type ProjectStatus = z.infer<typeof ProjectStatusSchema>;
